import { render, staticRenderFns } from "./MenuUserMark.vue?vue&type=template&id=037675f9&"
import script from "./MenuUserMark.vue?vue&type=script&lang=js&"
export * from "./MenuUserMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports